const MS_PER_DAY = 86_400_000;

/** Mirrors the backend constant of the same name; copy only - real expiry comes from the API. */
export const CASE_DESIGN_CREDIT_VALIDITY_DAYS = 90;

// Upper bound of each tier in days remaining. Anything above the yellow bound is
// green: the credit is live and comfortably in hand. These are days LEFT, so they
// do not move when the validity window changes - only the time spent in green does.
export const APPROVAL_CREDIT_YELLOW_MAX_DAYS = 35;
export const APPROVAL_CREDIT_AMBER_MAX_DAYS = 15;
export const APPROVAL_CREDIT_RED_MAX_DAYS = 10;

export type ApprovalCreditTone = 'green' | 'yellow' | 'amber' | 'red' | 'expired';

/** Whole days from `now` until `expiresAt`, rounded up so a partial day still reads as "1 day left". */
export function getApprovalCreditDaysLeft(expiresAt: string, now: Date = new Date()): number {
    return Math.ceil((new Date(expiresAt).getTime() - now.getTime()) / MS_PER_DAY);
}

/**
 * The pill's color tier. Total by design: a credit that exists always has a tone,
 * and a lapsed one reads as expired rather than silently vanishing. Whether a
 * credit exists at all is the caller's concern (a null expiresAt), not a tone.
 */
export function getApprovalCreditTone(daysLeft: number): ApprovalCreditTone {
    if (daysLeft <= 0) return 'expired';
    if (daysLeft <= APPROVAL_CREDIT_RED_MAX_DAYS) return 'red';
    if (daysLeft <= APPROVAL_CREDIT_AMBER_MAX_DAYS) return 'amber';
    if (daysLeft <= APPROVAL_CREDIT_YELLOW_MAX_DAYS) return 'yellow';
    return 'green';
}
